export default "__VITE_ASSET__ocwr5awi__"